/* app/js/src/components/calendar/calendar-search.component.scss */
.cursor-pointer {
  cursor: pointer;
}
:host {
  border: 1px solid #e3e6ea;
  border-radius: 4px;
  background-color: #ffffff;
  display: block;
  padding: 0 0 0 12px;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  justify-content: space-between;
}
:host input {
  border: none;
  line-height: 1em;
  font-size: 10px;
  margin: 0;
  padding: 0;
}
:host input:focus {
  outline: none;
}
:host input::-webkit-input-placeholder {
  font-size: 1em;
  color: #c9cdd6;
  font-weight: 700;
  line-height: 1em;
}
:host input:-moz-placeholder {
  font-size: 1em;
  color: #c9cdd6;
  font-weight: 700;
  line-height: 1em;
}
:host input::-moz-placeholder {
  font-size: 1em;
  color: #c9cdd6;
  font-weight: 700;
  line-height: 1em;
}
:host input:-ms-input-placeholder {
  font-size: 1em;
  color: #c9cdd6;
  font-weight: 700;
  line-height: 1em;
}
:host .search {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-justify-content: flex-end;
  -ms-flex-pack: flex-end;
  justify-content: flex-end;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  cursor: pointer;
  padding-right: 12px;
}
:host .search svg {
  height: 1em;
}
:host .search svg path {
  fill: #879baf;
  fill-rule: evenodd;
  -ms-transform: scale(1);
  -webkit-transform: scale(1);
  transform: scale(1);
  transform-origin: center center;
  -webkit-transform-origin: center center;
  -ms-transform-origin: center center;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
:host .search:active svg path {
  -ms-transform: scale(0.7);
  -webkit-transform: scale(0.7);
  transform: scale(0.7);
  fill: #232f3a;
}
:host .results {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
}
:host .results > span {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  color: #c9cdd6;
  font-weight: 300;
  font-size: 0.7em;
  margin-right: 1em;
}
:host .results button {
  background: none;
  border: none;
  border-left: 1px solid rgba(227, 230, 234, 0.5);
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
:host .results button svg path,
:host .results button svg polygon {
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  fill: #e1e6eb;
}
:host .results button#previous-result svg {
  transform-origin: center center;
  -webkit-transform-origin: center center;
  -ms-transform-origin: center center;
  -ms-transform: rotate(180deg) translateY(1px);
  -webkit-transform: rotate(180deg) translateY(1px);
  transform: rotate(180deg) translateY(1px);
}
:host .results button:hover {
  background-color: #dde3e7;
}
:host .results button:hover svg path,
:host .results button:hover svg polygon {
  fill: #879baf;
}
:host .results button:focus {
  outline: none;
}
/*# sourceMappingURL=calendar-search.component.css.map */
